module.exports = __webpack_public_path__ + "static/media/pic04.64a371bc.png";